const {
    PUBLIC_SITE_ORIGIN,
    PARENT_CHECKOUT_PATH,
    PARENT_LANDING_PATH,
} = require('./public-site-policy');
const { parentPlans } = require('./parent-plan-catalog.js');

const PARENT_FUNNEL_PAGE_NAMES = new Set([
    'Homepage New',
    'Parents',
    'LearnMore',
    'Signup',
]);

const CURRENT_CHECKOUT_URL = `${PUBLIC_SITE_ORIGIN}${PARENT_CHECKOUT_PATH}`;
const CURRENT_PARENTS_URL = `${PUBLIC_SITE_ORIGIN}${PARENT_LANDING_PATH}`;
const DEFAULT_TRIAL_LABEL = (
    parentPlans.find((plan) => plan.showOnParentCheckout !== false)?.trialLabel
    || 'Free 7-day trial'
).toLowerCase();

const LIVE_CHECKOUT_COPY = `<p>Parents can start with Muzology's ${DEFAULT_TRIAL_LABEL} and choose the plan that fits their family in our <a href="${CURRENT_CHECKOUT_URL}">live checkout</a>. Checkout always reflects the current parent plans and pricing.</p>`;
const LIVE_CHECKOUT_COPY_WITH_PREFIX = `<p><strong>Parents:</strong> Start with Muzology's ${DEFAULT_TRIAL_LABEL} and choose the plan that fits your family in our <a href="${CURRENT_CHECKOUT_URL}">live checkout</a>. Checkout always reflects the current parent plans and pricing.</p>`;

const EXACT_LINK_REWRITES = new Map([
    ['subscription-pricing', PARENT_CHECKOUT_PATH],
    ['/subscription-pricing', PARENT_CHECKOUT_PATH],
    ['https://www.muzology.com/subscription-pricing', CURRENT_CHECKOUT_URL],
    ['/offer', PARENT_LANDING_PATH],
    ['offer', PARENT_LANDING_PATH],
    ['https://www.muzology.com/offer', CURRENT_PARENTS_URL],
    ['/offers', PARENT_LANDING_PATH],
    ['offers', PARENT_LANDING_PATH],
    ['https://www.muzology.com/offers', CURRENT_PARENTS_URL],
    ['/parent-checkout', PARENT_CHECKOUT_PATH],
    ['parent-checkout', PARENT_CHECKOUT_PATH],
    ['https://www.muzology.com/parent-checkout', CURRENT_CHECKOUT_URL],
    ['/checkout?stage=1', PARENT_CHECKOUT_PATH],
    ['https://www.muzology.com/checkout?stage=1', CURRENT_CHECKOUT_URL],
]);

function normalizeParentFunnelLink(value) {
    if (typeof value !== 'string') {
        return value;
    }

    return EXACT_LINK_REWRITES.get(value) || value;
}

function sanitizeParentFunnelString(value) {
    if (typeof value !== 'string') {
        return value;
    }

    let nextValue = normalizeParentFunnelLink(value);

    nextValue = nextValue
        .replaceAll('https://www.muzology.com/checkout?stage=1', CURRENT_CHECKOUT_URL)
        .replaceAll('/checkout?stage=1', PARENT_CHECKOUT_PATH)
        .replaceAll('https://www.muzology.com/parent-checkout', CURRENT_CHECKOUT_URL)
        .replaceAll('/parent-checkout', PARENT_CHECKOUT_PATH)
        .replaceAll('https://www.muzology.com/offers', CURRENT_PARENTS_URL)
        .replaceAll('https://www.muzology.com/offer', CURRENT_PARENTS_URL)
        .replaceAll('/offers', PARENT_LANDING_PATH)
        .replaceAll('/offer', PARENT_LANDING_PATH)
        .replaceAll('subscription-pricing', PARENT_CHECKOUT_PATH);

    if (
        nextValue.includes('Times Tables Mini-Pack')
        || nextValue.includes('Math Success Plan')
        || nextValue.includes('monthly or annual plan')
    ) {
        return LIVE_CHECKOUT_COPY_WITH_PREFIX;
    }

    if (
        nextValue.includes('For a one-time payment of just $9.99')
        || nextValue.includes('99 days of access to Musical Times Tables')
    ) {
        return LIVE_CHECKOUT_COPY;
    }

    return nextValue;
}

function sanitizeParentFunnelValue(value) {
    if (Array.isArray(value)) {
        return value.map((item) => sanitizeParentFunnelValue(item));
    }

    if (value && typeof value === 'object') {
        return Object.fromEntries(
            Object.entries(value).map(([key, entryValue]) => [key, sanitizeParentFunnelValue(entryValue)])
        );
    }

    return sanitizeParentFunnelString(value);
}

function sanitizePublicPageData(pageName, data) {
    if (!PARENT_FUNNEL_PAGE_NAMES.has(pageName) || !data?.page) {
        return data;
    }

    return {
        ...data,
        page: sanitizeParentFunnelValue(data.page),
    };
}

module.exports = {
    PARENT_FUNNEL_PAGE_NAMES,
    LIVE_CHECKOUT_COPY,
    LIVE_CHECKOUT_COPY_WITH_PREFIX,
    normalizeParentFunnelLink,
    sanitizeParentFunnelString,
    sanitizePublicPageData,
};
